import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import { ALL_API_TAGS } from './apiTags';

const emptyApi = createApi({
  reducerPath: 'emptyApi',
  tagTypes: ALL_API_TAGS,
  baseQuery: fetchBaseQuery(),
  endpoints: () => ({})
});

export default emptyApi;
